import { createFileRoute, Navigate } from "@tanstack/react-router";

import React from "react";
import ACCOUNT_CONTEXT, { AccountProvider } from "src/context/account";

/**
 * The properties for {@link UserSwitch}
 */
export type UserSwitchProps = {};

/**
 * Redirect component for user permissions
 */
function UserSwitch(props: UserSwitchProps) {
    const userCtx = React.useContext(ACCOUNT_CONTEXT);

    if (userCtx.account.permissions === "Full") {
        return <Navigate to={"/a/dashboard"} />;
    } else {
        return <Navigate to={"/c/dashboard"} />;
    }
}

export const Route = createFileRoute("/")({
    /**
     * Wrapper around the index route to forward to the correct sub-path
     *
     * @returns JSX
     */
    component: () => (
        <AccountProvider>
            <UserSwitch />
        </AccountProvider>
    ),
});
